// extracted by mini-css-extract-plugin
export default {"container":"hero-module__container___GdldY","label":"hero-module__label___yQbqi"};